import { v4 } from "uuid";
import config from "./config";
import { ConnectionsType } from "./models/types";

const headers = {
  Accept: "application/json",
  Authorization: config.AUTH_HEADER,
  "Content-Type": "application/json",
};

const linkService = {
  createCompany: async () => {
    const userId = v4();

    const codatCompanyId = localStorage.getItem(userId);

    if (!codatCompanyId) {
      const getResult = await fetch(
        `${config.LINK_API_URL}/clients/${config.CLIENT_ID}/companies`,
        {
          method: "POST",
          headers,
          body: JSON.stringify({
            name: userId,
          }),
        }
      );

      if (!getResult.ok) {
        throw new Error("Could not create a company");
      }

      const resultBody = await getResult.json();
      const companyId = resultBody.id;

      if (companyId) {
        localStorage.setItem(userId, companyId);
      }

      return { userId };
    }
  },
  integrations: async (userId: string) => {
    const codatCompanyId = localStorage.getItem(userId);
    const getResult = await fetch(
      `${config.LINK_API_URL}/companies/${codatCompanyId}/integrations?page=1&pageSize=100&sourceType=accounting`,
      {
        method: "GET",
        headers,
      }
    );

    if (!getResult.ok) {
      throw new Error("Could not get any integrations");
    }

    const resultBody = await getResult.json();
    return resultBody.results;
  },
  allConnections: async (userId: string) => {
    const codatCompanyId = localStorage.getItem(userId);

    if (!codatCompanyId) {
      throw new Error("Company ID is not defined");
    }

    const getResult = await fetch(
      `${config.API_URL}/companies/${codatCompanyId}/connections?page=1&pageSize=100`,
      {
        method: "GET",
        headers,
      }
    );
    if (!getResult.ok) {
      throw new Error("Could not get connections");
    }

    return getResult.json();
  },
  connections: async (
    userId: string,
    connectionId: string
  ): Promise<ConnectionsType> => {
    const codatCompanyId = localStorage.getItem(userId);
    if (!codatCompanyId) {
      throw new Error("Company ID is not defined");
    }
    const getResult = await fetch(
      `${config.LINK_API_URL}/companies/${codatCompanyId}/connections/${connectionId}/status/`,
      {
        method: "GET",
        headers,
      }
    );
    if (!getResult.ok) {
      throw new Error("Could not get connections");
    }

    return getResult.json();
  },
  postConnection: async (userId: string, integrationKey: string) => {
    if (!userId) {
      throw new Error("userId is a required field");
    }

    if (!integrationKey) {
      throw new Error("integrationKey is a required field");
    }

    const codatCompanyId = localStorage.getItem(userId);

    if (!codatCompanyId) {
      throw new Error("User id has not been set up");
    }

    try {
      const getResult = await fetch(
        `${config.LINK_API_URL}/companies/${codatCompanyId}/connections`,
        {
          method: "POST",
          headers,
          body: JSON.stringify({
            platformKey: integrationKey,
          }),
        }
      );
      if (!getResult.ok) {
        throw new Error("Could not create connection");
      }
      return getResult.json();
    } catch (e) {
      console.error(e);
    }
  },
  getBranding: async () => {
    try {
      const getResult = await fetch(`${config.API_URL}/profile/branding`, {
        method: "GET",
        headers,
      });
      if (!getResult.ok) {
        throw new Error("Could not get branding");
      }
      return getResult.json();
    } catch (e) {
      console.error(e);
    }
  },
  getAccessToken: async (userId: string) => {
    const codatCompanyId = localStorage.getItem(userId);

    if (!codatCompanyId) {
      throw new Error("Company ID is not defined");
    }

    try {
      const getResult = await fetch(
        `${config.API_URL}/companies/${codatCompanyId}/connectionManagement/accessToken`,
        {
          method: "GET",
          headers,
        }
      );
      if (!getResult.ok) {
        throw new Error("Could not get auth token");
      }
      return getResult.json();
    } catch (e) {
      console.error(e);
    }
  },
};

export { linkService };
